<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
  >
    <!-- 背景装饰层 -->
    <div class="bg-decoration">
      <div class="tech-grid"></div>
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
      <div class="gradient-orb orb-3"></div>
    </div>
    
    <!-- 动态小挂件 -->
    <div class="floating-widgets">
      <div class="widget widget-1">
        <div class="widget-inner"></div>
      </div>
      <div class="widget widget-2">
        <div class="widget-inner"></div>
      </div>
      <div class="widget widget-3">
        <div class="widget-inner"></div>
      </div>
      <div class="widget widget-4">
        <div class="widget-inner"></div>
      </div>
    </div>

    <Header3  id="header" />
    <Banner/>
    <div class="home">
      <router-view />
    </div>
    <Footer id="footer" />
  </div>
</template>

<script>
import Vue from "vue";
import { mixinDevice } from "@/utils/mixin.js";
import Header3 from "@/components/header/Header3";
import Banner from '@/components/header/Banner'
import sideMenu from "../components/sideMenu";
import Footer from "@/components/footer/Footer";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header3,
    Banner,
    Footer,
    sideMenu,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 50%, #f0f7ff 100%);
  overflow: hidden;

  // 背景装饰层
  .bg-decoration {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;

    // 科技网格背景
    .tech-grid {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: 
        linear-gradient(rgba(36, 166, 233, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(36, 166, 233, 0.03) 1px, transparent 1px);
      background-size: 50px 50px;
      animation: gridMove 20s linear infinite;
      opacity: 0.5;
    }

    // 渐变光球装饰
    .gradient-orb {
      position: absolute;
      border-radius: 50%;
      filter: blur(60px);
      opacity: 0.15;
      animation: float 15s ease-in-out infinite;
      
      &.orb-1 {
        width: 400px;
        height: 400px;
        background: radial-gradient(circle, rgba(36, 166, 233, 0.4) 0%, transparent 70%);
        top: 10%;
        left: -10%;
        animation-delay: 0s;
      }

      &.orb-2 {
        width: 300px;
        height: 300px;
        background: radial-gradient(circle, rgba(24, 144, 255, 0.3) 0%, transparent 70%);
        top: 60%;
        right: -5%;
        animation-delay: 5s;
      }

      &.orb-3 {
        width: 350px;
        height: 350px;
        background: radial-gradient(circle, rgba(36, 166, 233, 0.25) 0%, transparent 70%);
        bottom: 20%;
        left: 50%;
        animation-delay: 10s;
      }
    }
  }

  // 动态小挂件
  .floating-widgets {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    overflow: hidden;

    .widget {
      position: absolute;
      pointer-events: none;

      .widget-inner {
        width: 100%;
        height: 100%;
        border: 2px solid rgba(36, 166, 233, 0.2);
        border-radius: 8px;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(36, 166, 233, 0.05) 100%);
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 20px rgba(36, 166, 233, 0.1);
        animation: widgetFloat 8s ease-in-out infinite;
      }

      &.widget-1 {
        width: 80px;
        height: 80px;
        top: 15%;
        right: 8%;
        animation: widgetMove1 20s ease-in-out infinite;
        transform: rotate(45deg);
      }

      &.widget-2 {
        width: 60px;
        height: 60px;
        top: 45%;
        left: 5%;
        animation: widgetMove2 18s ease-in-out infinite;
        transform: rotate(-30deg);
      }

      &.widget-3 {
        width: 100px;
        height: 100px;
        bottom: 25%;
        right: 12%;
        animation: widgetMove3 22s ease-in-out infinite;
        transform: rotate(60deg);
        border-radius: 50%;
        
        .widget-inner {
          border-radius: 50%;
        }
      }

      &.widget-4 {
        width: 70px;
        height: 70px;
        bottom: 15%;
        left: 8%;
        animation: widgetMove4 16s ease-in-out infinite;
        transform: rotate(-45deg);
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        
        .widget-inner {
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }
      }
    }
  }

  #header,
  #footer {
    flex: 0 0 auto;
    position: relative;
    z-index: 10;
  }

  .banner-wrap {
    padding: 80px 0;
    background: #24a6e9;
    position: relative;
    z-index: 10;
    
    .banner-bg {
      position: absolute;
      width: 100%;
    }
    
    .banner {
      margin: auto;
      overflow: hidden;
      border-radius: 28px;
      box-shadow: 0px 6px 10px #0303031f;
    }
  }

  .home {
    flex: 1 1 auto;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 10px;
   // background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(36, 166, 233, 0.08);
    position: relative;
    z-index: 10;
    margin-top: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(36, 166, 233, 0.1);

    .pageLeft {
      width: 180px;
      height: calc(100vh - 75px);
      background: #fff;
    }
  }

  /deep/.ant-list-pagination {
    text-align: center;
  }

  // 动画定义
  @keyframes gridMove {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(50px, 50px);
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translate(0, 0) scale(1);
    }
    33% {
      transform: translate(30px, -30px) scale(1.1);
    }
    66% {
      transform: translate(-20px, 20px) scale(0.9);
    }
  }

  @keyframes widgetFloat {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
      opacity: 0.6;
    }
    50% {
      transform: translateY(-20px) rotate(180deg);
      opacity: 1;
    }
  }

  @keyframes widgetMove1 {
    0%, 100% {
      transform: translate(0, 0) rotate(45deg);
    }
    25% {
      transform: translate(30px, -40px) rotate(60deg);
    }
    50% {
      transform: translate(-20px, -60px) rotate(30deg);
    }
    75% {
      transform: translate(-40px, -20px) rotate(50deg);
    }
  }

  @keyframes widgetMove2 {
    0%, 100% {
      transform: translate(0, 0) rotate(-30deg);
    }
    33% {
      transform: translate(-30px, 30px) rotate(-45deg);
    }
    66% {
      transform: translate(20px, -20px) rotate(-15deg);
    }
  }

  @keyframes widgetMove3 {
    0%, 100% {
      transform: translate(0, 0) rotate(60deg);
    }
    25% {
      transform: translate(40px, 30px) rotate(90deg);
    }
    50% {
      transform: translate(-30px, 40px) rotate(30deg);
    }
    75% {
      transform: translate(30px, -30px) rotate(75deg);
    }
  }

  @keyframes widgetMove4 {
    0%, 100% {
      transform: translate(0, 0) rotate(-45deg);
    }
    50% {
      transform: translate(25px, -35px) rotate(-60deg);
    }
  }

  // 移动端适配
  &.mobile {
    .bg-decoration {
      .gradient-orb {
        opacity: 0.08;
        
        &.orb-1,
        &.orb-2,
        &.orb-3 {
          width: 200px;
          height: 200px;
        }
      }
    }

    .floating-widgets {
      .widget {
        opacity: 0.5;
        
        &.widget-1,
        &.widget-2,
        &.widget-3,
        &.widget-4 {
          width: 40px;
          height: 40px;
        }
      }
    }

    .home {
      padding: 15px 8px;
      margin-top: 10px;
      margin-bottom: 10px;
      border-radius: 12px;
    }
  }
}
</style>